import "../../style/style.css";
import {Box2} from "../../components/Box/Box.js"


function GamePage() {
  return (
    <div className="bg">
      <Box2 children="text">의문점</Box2>
      
      <div>
      </div>

    </div>
  );
}

export default GamePage;
